import { Flex, useColorModeValue } from "@chakra-ui/react";

interface CardProps {
  children: JSX.Element;
  width?: any;
  height?: any;
}

export default function Card({
  children,
  width,
  height,
}: CardProps): JSX.Element {
  return (
    <Flex
      padding={6}
      shadow={"md"}
      justifyContent={"center"}
      alignItems={"center"}
      direction={"column"}
      gap={6}
      borderRadius={"xl"}
      borderColor={useColorModeValue("#d1d2d4", "#474c56")}
      backgroundColor={useColorModeValue("#e8e8e9", "#303641")}
      width={width}
    >
      {children}
    </Flex>
  );
}
